// import node module libraries
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChatSettingState {
  isTechMode: boolean;
  isAutoLogin: boolean;
}

const initialState: ChatSettingState = {
  isTechMode: false,
  isAutoLogin: false,
};

const chatSettingSlice = createSlice({
  name: "chatSetting",
  initialState,
  reducers: {
    setTechnicalMode: (state, action: PayloadAction<boolean>) => {
      state.isTechMode = action.payload;
    },
    setAutoLogin: (state, action: PayloadAction<boolean>) => {
      state.isAutoLogin = action.payload;
    },
  },
});

export const { setTechnicalMode, setAutoLogin } = chatSettingSlice.actions;

export default chatSettingSlice.reducer;
